const InvoiceExtensionTypeEnum =
{
    PDF: 'PDF',
    Excel: 'Excel',
    Word: 'Word',
};

export default InvoiceExtensionTypeEnum;